// Mechanism schematics, not network measurements or production topology diagrams.
const C={paper:'#ebe8dd',ink:'#364337',rust:'#c7653b',sage:'#8ba08d',blue:'#748a95'};
const esc=v=>String(v).replaceAll('&','&amp;').replaceAll('<','&lt;').replaceAll('>','&gt;');
const txt=(x,y,v,size=12,color=C.ink)=>`<text x="${x}" y="${y}" font-size="${size}" fill="${color}" text-anchor="middle">${esc(v)}</text>`;
const line=(a,b,c,d,color=C.ink,dash='')=>`<line x1="${a}" y1="${b}" x2="${c}" y2="${d}" stroke="${color}" stroke-width="2" ${dash?'stroke-dasharray="5 4"':''}/>`;
const rect=(x,y,w,h,color=C.paper)=>`<rect x="${x}" y="${y}" width="${w}" height="${h}" rx="4" fill="${color}" stroke="${C.ink}"/>`;
const box=(x,y,w,h,v,color=C.paper)=>rect(x,y,w,h,color)+txt(x+w/2,y+h/2+4,v);
const circle=(x,y,r,color=C.sage)=>`<circle cx="${x}" cy="${y}" r="${r}" fill="${color}" stroke="${C.ink}"/>`;
const arrow=(x,y,u,v,color=C.rust)=>{const a=Math.atan2(v-y,u-x);return line(x,y,u,v,color)+`<path d="M${u-7*Math.cos(a-.45)} ${v-7*Math.sin(a-.45)} L${u} ${v} L${u-7*Math.cos(a+.45)} ${v-7*Math.sin(a+.45)}" fill="none" stroke="${color}" stroke-width="2"/>`;};
export function networkDiagram(id,language='ja'){
 const t=(ja,en)=>language==='ja'?ja:en;
 const title=(ja,en)=>txt(240,29,t(ja,en),14);
 const foot=(ja,en)=>txt(240,253,t(ja,en),11);
 let s='';
 switch(id){
 case 'tribes-replication':
  s=title('接続ごとに範囲と優先度を選ぶ','Select scope and priority per connection');
  s+=rect(24,57,155,145)+txt(101,78,t('世界の物体','World objects'));
  for(const [x,y,c] of [[56,105,C.rust],[119,103,C.sage],[79,149,C.rust],[147,155,C.blue],[41,176,C.sage]])s+=circle(x,y,10,c);
  s+=arrow(181,118,218,118)+box(224,92,102,52,t('範囲・差分','Scope + changes'));
  s+=arrow(328,115,361,82)+arrow(328,123,361,181);
  s+=box(368,58,88,49,t('接続A','Client A'))+box(368,158,88,49,t('接続B','Client B'));
  s+=txt(275,175,t('帯域内で優先','Prioritize within'))+txt(275,193,t('順位を付ける','bandwidth limits'));
  s+=foot('全物体の全状態を毎回送る構成ではありません。','Scope and changed fields determine each update.');break;
 case 'eve-tidi':
  s=title('過負荷時にゲーム内時間を遅くする','Slow game time when the node is overloaded');
  s+=txt(94,69,t('現実の時間','Wall time'))+txt(92,137,t('通常時','Normal'))+txt(92,202,t('過負荷時','Overloaded'));
  s+=arrow(159,77,443,77,C.ink);
  for(let i=0;i<7;i++)s+=line(168+i*40,68,168+i*40,85,C.ink);
  for(let i=0;i<6;i++)s+=rect(166+i*42,112,32,37,C.sage)+txt(182+i*42,135,String(i+1));
  for(let i=0;i<3;i++)s+=rect(166+i*84,178,71,37,C.blue)+txt(201+i*84,201,String(i+1));
  s+=foot('同じ実時間に進むゲーム時間が減ります。比率は説明用です。','Less game time advances per second; ratios are illustrative.');break;
 case 'destiny-shared-world':
  s=title('境界を越えて体験と担当が変わる','Experiences and ownership change at boundaries');
  s+=rect(23,69,190,134)+rect(266,69,190,134)+txt(118,91,t('領域A','Region A'))+txt(362,91,t('領域B','Region B'));
  s+=box(50,145,136,34,t('担当A','Owner A'),C.sage)+box(293,145,136,34,t('担当B','Owner B'),C.blue);
  s+=circle(114,116,11,C.rust)+arrow(136,116,342,116)+circle(362,116,11,C.rust);
  s+=line(239,56,239,212,C.ink,true)+txt(240,225,t('状態・参加・引き継ぎ','State, participation, and handoff'));
  s+=foot('概念図です。実際のDestiny構成をそのまま描いてはいません。','Conceptual boundary handoff, not Destiny’s exact topology.');break;
 case 'riot-chat-shards':
  s=title('地域ごとの接続とチャット処理','Regional connections and chat processing');
  for(const [x,label] of [[24,t('地域A','Region A')],[266,t('地域B','Region B')]]){
   s+=rect(x,57,190,165)+txt(x+95,79,label)+circle(x+45,108,10,C.rust)+circle(x+145,108,10,C.rust);
   s+=arrow(x+45,121,x+54,152)+arrow(x+145,121,x+137,152);
   s+=box(x+20,158,66,34,t('ノード1','Node 1'),C.sage)+box(x+105,158,66,34,t('ノード2','Node 2'),C.sage)+line(x+87,175,x+104,175,C.ink);
  }
  s+=line(239,77,239,204,C.ink,true);
  s+=foot('2015年事例では、地域間のチャットは分離されていました。','In the 2015 case, chat did not cross regional boundaries.');break;
 case 'agones-orchestration':
  s=title('配置の管理と試合の計算を分ける','Separate server allocation from match simulation');
  s+=box(21,60,131,44,t('参加者の組','Matched players'))+arrow(153,82,200,82)+box(204,60,252,44,t('配置・ライフサイクルの管理','Allocation and lifecycle management'),C.sage);
  for(let i=0;i<3;i++)s+=arrow(253+i*66,106,253+i*66,148)+box(218+i*79,153,70,57,t(`試合${i+1}`,`Match ${i+1}`),i===0?C.rust:C.paper);
  s+=txt(85,163,t('各プロセスが','Each process'))+txt(85,183,t('状態を保持','owns state'));
  s+=foot('プロセスの増加だけでは、ひとつの世界の計算は分割できません。','More processes do not automatically partition one world.');break;
 case 'valorant-lag-compensation':
  s=title('入力・受信・判定には時刻の差がある','Input, receipt, and validation have different times');
  s+=txt(65,79,t('射撃側','Shooter'))+txt(65,137,t('サーバー','Server'))+txt(65,195,t('対象の履歴','Target history'));
  for(const y of [84,142,200])s+=arrow(130,y,453,y,C.ink);
  s+=circle(207,84,6,C.rust)+arrow(211,90,304,134)+circle(310,142,6,C.rust);
  s+=txt(222,61,t('入力','Input'))+txt(354,121,t('受信・検証','Receive + validate'));
  for(let i=0;i<6;i++)s+=rect(151+i*49,187,12,25,C.blue);
  s+=arrow(310,151,207,183)+txt(346,227,t('過去の状態を参照','Consult historical state'));
  s+=foot('遡る時間には上限が必要です。画面の時刻は完全には揃いません。','Rewind needs limits; both views cannot become simultaneous.');break;
 case 'valorant-load-testing':
  s=title('試合の負荷と基盤の負荷を分けて測る','Measure match load and platform load separately');
  s+=box(25,70,131,49,t('模擬プレイヤー','Simulated players'),C.sage)+arrow(159,94,203,94)+box(210,59,242,69,t('参加・マッチング・結果保存','Join, matchmake, store results'));
  s+=arrow(329,131,329,156)+box(255,161,151,47,t('試合の計算','Match simulation'),C.blue);
  s+=box(24,172,153,37,t('監視・遅延・失敗','Metrics and failures'))+arrow(251,184,181,184);
  s+=foot('模擬利用者数は、ひとつの戦闘の参加人数とは異なります。','Simulated platform users are not players in one battle.');break;
 default:return null;
 }
 return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 480 280" role="img"><rect width="480" height="280" fill="${C.paper}"/>${s}</svg>`;
}
